export const POLICY_FOR_EVERYONE = 'Policy For Everyone';
export const CPARS_ACCESS = 'CPARS Access';
export const CPARS_ARTIFACT_ACCESS = 'CPARS Artifact Access';
export const GWAC_ACCESS = 'GWAC Access';
export const DEFAULT_ACCESS_POLICY = 'Default Asset Policy';
export const LOGGED_VIDEO_POLICY = 'Default Logged Video Policy';
